import React from "react";

const ITEMS = [
  "FDM // PLA · PETG · ABS · ASA · TPU",
  "MAX VOLUME // 350 × 350 × 350 MM",
  "0.1MM LAYER HEIGHT",
  "STL · OBJ · STEP · 3MF",
  "BATCH · PROTOTYPE · PRODUCTION",
  "FINISHING · SANDING · PAINT · VAPOR SMOOTH",
];

export const Marquee = () => {
  const list = [...ITEMS, ...ITEMS];
  return (
    <div className="border-y border-[#2A2A2A] bg-[#0A0A0A] overflow-hidden" data-testid="marquee">
      <div className="marquee-track py-4">
        {list.map((t, i) => (
          <span
            key={i}
            className="font-mono-ui text-xs md:text-sm tracking-[0.3em] uppercase text-white/70 px-8 whitespace-nowrap flex items-center"
          >
            <span className="text-[#FF5722] mr-8">◆</span>
            {t}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
